var _path, _g, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMir16 = function SvgMir16(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.5C0 1.11929 1.11929 0 2.5 0H21.5C22.8807 0 24 1.11929 24 2.5V13.5C24 14.8807 22.8807 16 21.5 16H2.5C1.11929 16 0 14.8807 0 13.5V2.5Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_145_512)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.79754 6V6.002C7.79538 6.002 7.11454 6 6.93298 6.6016C6.76655 7.15322 6.29753 8.6762 6.28456 8.71817H6.15488C6.15488 8.71817 5.67505 7.16122 5.50646 6.5996C5.3249 5.998 4.6419 6 4.6419 6H3.08569V10.5769H4.6419V7.85875H4.70674H4.77158L5.67937 10.5769H6.76007L7.66786 7.86075H7.79754V10.5769H9.35375V6H7.79754Z",
    fill: "#4DB45E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4822 6C13.4822 6 13.0261 6.03797 12.8121 6.47968L11.7098 8.71817H11.5801V6H10.0239V10.5769H11.4937C11.4937 10.5769 11.9713 10.537 12.1853 10.0972L13.266 7.85875H13.3957V10.5769H14.9519V6H13.4822Z",
    fill: "#4DB45E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6433 8.07857V10.5769H17.1995V9.11787H18.8854C19.6203 9.11787 20.2428 8.68416 20.474 8.07857H15.6433Z",
    fill: "#4DB45E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8854 6H15.425C15.598 6.87141 16.3047 7.57094 17.219 7.79879C17.4265 7.85076 17.6448 7.87874 17.8696 7.87874H20.5368C20.5605 7.77481 20.5713 7.66888 20.5713 7.55895C20.5713 6.69753 19.817 6 18.8854 6Z",
    fill: "url(#paint0_linear_145_512)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 0.5H21.5V-0.5H2.5V0.5ZM23.5 2.5V13.5H24.5V2.5H23.5ZM21.5 15.5H2.5V16.5H21.5V15.5ZM0.5 13.5V2.5H-0.5V13.5H0.5ZM2.5 15.5C1.39543 15.5 0.5 14.6046 0.5 13.5H-0.5C-0.5 15.1569 0.843146 16.5 2.5 16.5V15.5ZM23.5 13.5C23.5 14.6046 22.6046 15.5 21.5 15.5V16.5C23.1569 16.5 24.5 15.1569 24.5 13.5H23.5ZM21.5 0.5C22.6046 0.5 23.5 1.39543 23.5 2.5H24.5C24.5 0.843146 23.1569 -0.5 21.5 -0.5V0.5ZM2.5 -0.5C0.843146 -0.5 -0.5 0.843146 -0.5 2.5H0.5C0.5 1.39543 1.39543 0.5 2.5 0.5V-0.5Z",
    fill: "#080808",
    fillOpacity: 0.08
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_145_512",
    x1: 15.4255,
    y1: 6.93937,
    x2: 20.5713,
    y2: 6.93937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00B4E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#088CCB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_145_512"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.4857,
    height: 4.57692,
    fill: "white",
    transform: "translate(3.08569 6)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMir16);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "mir-16.2ba7aed3d3851e1c1781dc6495367f3c.svg";